// supabaseClient.js
import { createClient } from '@supabase/supabase-js';
import { createOrganisationContextFetch } from './organisationContextFetch';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const expectedSupabaseHost = process.env.REACT_APP_EXPECTED_SUPABASE_HOST;

if (!supabaseUrl || !supabaseAnonKey) {
	throw new Error(
		'Missing Supabase configuration. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env'
	);
}

if (expectedSupabaseHost) {
	let configuredHost = '';
	try {
		configuredHost = new URL(supabaseUrl).host;
	} catch (_error) {
		throw new Error(`Invalid REACT_APP_SUPABASE_URL: ${supabaseUrl}`);
	}

	if (configuredHost !== expectedSupabaseHost) {
		throw new Error(
			`Supabase project mismatch. Expected host "${expectedSupabaseHost}", got "${configuredHost}". Update .env before running demos.`
		);
	}
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
	global: {
		fetch: createOrganisationContextFetch((...args) => fetch(...args)),
	},
});
